module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"customerManage.title":"Customer - {customerName}","customerManage.failedToLoad":"There was an issue loading this customer."}}')
  delete Component.options._Ctor
}
